import { render, staticRenderFns } from "./BlogView.vue?vue&type=template&id=6df6738f&scoped=true"
import script from "./BlogView.vue?vue&type=script&lang=js"
export * from "./BlogView.vue?vue&type=script&lang=js"
import style0 from "./BlogView.vue?vue&type=style&index=0&id=6df6738f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df6738f",
  null
  
)

export default component.exports